import React, { useState } from 'react';
import { handlePointerDown} from '../../lib/modal-helper';
import { selectAllStrings } from '../language/languageSlice';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faBolt, faCrown } from '@fortawesome/free-solid-svg-icons';
import '../../stylesheets/TrialEndModal.css';
import { loggedOut } from './userSlice';
import { useHistory } from 'react-router-dom';
import constants from '../../constants';
import BuyAccessButton from '../../components/BuyAccessButton';

const TrialEndModal = ({onGoAhead}) => {
    const strings = useSelector(selectAllStrings);

    const dispatch = useDispatch();
    const history = useHistory();

    const closeModal = (event) => {
        event.preventDefault();
        dispatch(loggedOut());
        history.push('/');
    };



    return <div className="modal" id="trial_end_modal">
        <div className="modal-body" id="trial_end_modal_body">
            <div className="modal-border" onPointerDown={event => handlePointerDown(event, 'trial_end_modal_body')}>
                <div className="move-handler"></div>
            </div>
            <div className="modal-content">
                <div className="modal-header" onPointerDown={event => handlePointerDown(event, 'trial_end_modal_body')}>
    
                    <a className="close-modal" onPointerDown={event => {
                                event.preventDefault();
                                event.stopPropagation();
                               }} onClick={closeModal}>X</a>
                    <span onPointerDown={event => event.preventDefault()}>{strings.trial_expired}</span>
                    <hr/>
                </div>
                <div className="modal-text">{strings.we_got}<br/>{strings.stay}</div>
                <div className="advantage-list">
                    <div className="advantage">
                        <div className="icon">
                            <FontAwesomeIcon icon={faThumbsUp}/>
                        </div>
                        <div className="intro">
                            <div className="title">{strings.advantage_1}</div>
                            <div className="description">{strings.advantage_1_description}</div>
                        </div>
                    </div>
                    <div className="advantage">
                        <div className="icon">
                            <FontAwesomeIcon icon={faBolt}/>
                        </div>
                        <div className="intro">
                            <div className="title">{strings.advantage_2}</div>
                            <div className="description">{strings.advantage_2_description}</div>
                        </div>
                    </div>
                    <div className="advantage">
                        <div className="icon">
                            <FontAwesomeIcon icon={faCrown}/>
                        </div>
                        <div className="intro">
                            <div className="title">{strings.advantage_3}</div>
                            <div className="description">{strings.advantage_3_description}</div>
                        </div>
                    </div>
                </div>
                <BuyAccessButton/>
                <div className="support">{strings.for_any} <a href="tel:0685305377">0685305377</a> 
                    {constants.environment == 'iOS' ? null :
                    <React.Fragment>
                        {strings.or_write} 
                        <a href="mailto:info@pleinairclub.it">info@pleinairclub.it</a>
                    </React.Fragment>}
                </div>
            </div>
        </div>
    </div>;
};

export default TrialEndModal;

